export const calcPercentage = (num: number, denom: number): number => {
  const percentage = denom > 0 ? num / denom : 0;
  return percentage > 100 ? 100 : percentage;
};

export enum SpeedUnit {
  kmph = 'km/h',
  mps = 'm/s',
  mph = 'mph',
}

export enum DistanceUnit {
  Metres = 'Metres',
  Kilometers = 'Kilometres',
  Feet = 'Feet',
  Miles = 'Miles',
}

const speedFromKmph = (value: number, to: SpeedUnit): number => {
  switch (to) {
    case SpeedUnit.mps:
      return (value * 1000) / 3600;
    case SpeedUnit.kmph:
      return value;
    case SpeedUnit.mph:
      return value * 0.621371;
  }
};

const speedFromMps = (value: number, to: SpeedUnit): number => {
  switch (to) {
    case SpeedUnit.kmph:
      return value * 3.6;
    case SpeedUnit.mps:
      return value;
    case SpeedUnit.mph:
      return value * 2.23694;
  }
};

const speedFromMph = (value: number, to: SpeedUnit): number => {
  switch (to) {
    case SpeedUnit.kmph:
      return value * 1.60934;
    case SpeedUnit.mps:
      return value * 0.44704;
    case SpeedUnit.mph:
      return value;
  }
};

export const speedConversion = (value: number, from: SpeedUnit, to: SpeedUnit): number => {
  switch (from) {
    case SpeedUnit.kmph:
      return speedFromKmph(value, to);
    case SpeedUnit.mps:
      return speedFromMps(value, to);
    case SpeedUnit.mph:
      return speedFromMph(value, to);
  }
};

export const distanceToMetresConversion = (value: number, from: DistanceUnit): number => {
  switch (from) {
    case DistanceUnit.Metres:
      return value;
    case DistanceUnit.Kilometers:
      return value * 1000;
    case DistanceUnit.Feet:
      return value * 0.3048;
    case DistanceUnit.Miles:
      return value * 1609.34;
  }
};

export const distanceFromMetresConversion = (value: number, to: DistanceUnit): number => {
  switch (to) {
    case DistanceUnit.Metres:
      return value;
    case DistanceUnit.Kilometers:
      return value / 1000;
    case DistanceUnit.Feet:
      return value * 3.28084;
    case DistanceUnit.Miles:
      return value * 0.000621371;
  }
};

export const constrain = (value: number, min: number, max: number): number => {
  return Math.max(Math.min(value, max), min);
};
